import { useState } from 'react';

export function useExpandedCategories() {
  const [expandedMap, setExpandedMap] = useState<Record<string, boolean>>({});

  const toggleCategory = (categoryValue: string) => {
    setExpandedMap((prev) => ({
      ...prev,
      [categoryValue]: !prev[categoryValue],
    }));
  };

  return {
    expandedMap,
    toggleCategory,
  };
}
